//Please add the language resource
const soldto = {
  customerCode:'CustomerCode',
  customerShortName:'CustomerShortName',
  customerName: 'CustomerName',
  customerAddr: 'CustomerAddr',
  tradeLineCode:'TradeLineCode',
  tradeLineName:'TradeLineName',
  businessType:'BusinessType',
  mnemonicCode:'MnemonicCode',
  contact:'Contact',
  tel: 'Tel',
  email:'Email',
  createTime:'CreateTime',
  creator:'Creator',
  updateTime:'UpdateTime',
  updater:'Updater',
  msg:{
  }
};
export default soldto



// WEBPACK FOOTER //
// ./src/page/md/soldto/lang/soldto.en.js